import React, { ChangeEvent, useState } from "react";
import { CompleteEditor } from "../Molecule/MinimalEditor";
import RichTextTranslator from "../../Logic/RichTextTranslator";
import debounce from "lodash.debounce";
import { validateLink } from "../../Logic/utils";
import { JSONContent } from "@tiptap/react";
import { ElementType, TextElement } from "types/types";

/*
  @function LinkEditor
  edit Link
  @param text {object} - handles text information
  @param onUpdateStrings {function} - update simple strings
  @param onUpdatdateRichtText {function} - update rich text
*/
export default function LinkEditor({
  text,
  onUpdateStrings,
  onUpdateRichText,
}: {
  text?: {
    name: string;
    description?: TextElement;
    link_id?: string;
    address?: string;
  };
  onUpdateStrings: (
    value: ChangeEvent<HTMLInputElement>,
    key: string,
    type: string,
    id: string
  ) => void;
  onUpdateRichText: (
    value: JSONContent,
    key: string,
    type: string,
    id: string
  ) => void;
}) {
  const [validation, setValidation] = useState({ link: true });
  const description =
    text?.description && typeof text.description === "string"
      ? JSON.parse(text.description)
      : text?.description !== undefined
      ? text.description
      : {};

  /*
    for some reason some descriptions have only one 'p' element
  */

  if (JSON.stringify(description) === JSON.stringify({ text: [["p"]] })) {
    description.text = [];
  }

  return (
    <>
      <label className="text-center m-2">Name</label>
      <input
        type="text"
        id="name"
        name="first"
        defaultValue={text?.name ? text.name : ""}
        className="border border-2 border-black m-6"
        onChange={debounce((v: ChangeEvent<HTMLInputElement>) =>
          onUpdateStrings(
            v,
            "name",
            ElementType.Link,
            text?.link_id !== undefined ? text.link_id : ""
          )
        )}
      />
      <label className="text-center m-2">Link </label>
      <input
        type="text"
        id="link"
        name="first"
        defaultValue={text?.address ? text.address : ""}
        className="border border-2 border-black m-6"
        onChange={debounce((v: ChangeEvent<HTMLInputElement>) => {
          setValidation({ ...validation, link: validateLink(v.target.value) });
          onUpdateStrings(
            v,
            "address",
            ElementType.Link,
            text?.link_id !== undefined ? text.link_id : ""
          );
        })}
      />
      {!validation.link && (
        <label className="text-center mb-2 text-rose-900">not valid</label>
      )}
      <label className="text-center m-2">Link Content</label>
      <CompleteEditor
        className="border border-2 border-black m-6 h-64"
        onUpdate={(v) =>
          onUpdateRichText(
            v,
            "description",
            ElementType.Link,
            text?.link_id !== undefined ? text.link_id : ""
          )
        }
        text={
          "text" in description
            ? {
                type: "doc",
                content: RichTextTranslator({ text: description.text }),
              }
            : description
        }
        elementAskingRerender={[]}
        element={{ link: text?.link_id }}
      />
    </>
  );
}
